import React from 'react';
import {Link, Redirect} from 'react-router-dom';
import {
    Breadcrumb,
    Icon,
    Card,
    Row,
    Col,
    Divider,
    Checkbox,
    InputNumber,
    Input,
    Upload,
    Button,
    message,
    DatePicker
} from 'antd';
import {connect} from 'react-redux';
import * as moment from 'moment';
import {
    fetchApplications,
    patchApplication,
    uploadDocument,
    deleteDocument
} from '../actions';
import Map from './Map';
import Document from './Document';
message.config({top: 11});

const { TextArea } = Input;

class Application extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            badge_cost_quoted: 0,
            property_cost_quoted: 0,
            number_of_properties: 0,
            contract_start_date: null,
            start_number: '',
            serverErrors: null,
            viewNotes: false,
            notes: ''
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const {application, isFetching} = nextProps;
        if (isFetching || application.isFetching) {
            return null;
        }

        if (application.error) {
            return {...prevState, serverErrors: application.error}
        }
        if (!application.error && prevState.serverErrors) {
            return {...prevState, serverErrors: null}
        }

        const {
            badge_cost_quoted,
            property_cost_quoted,
            number_of_properties,
            notes,
            contract_start_date,
            start_number,
        } = application;

        return {
            badge_cost_quoted,
            property_cost_quoted,
            number_of_properties,
            notes,
            contract_start_date,
            start_number
        };
    }
    renderBreadcrump() {
        const {match: {params: {id}}, location: {state: {from} = {}}} = this.props;
        return (
            <Breadcrumb style={{marginBottom: 16}}>
                <Breadcrumb.Item>
                    <Link to={{
                        pathname: '/admin/applications',
                        search: from
                    }}><Icon type='solution'/> Applications</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>{id}</Breadcrumb.Item>
            </Breadcrumb>
        );
    }
    static notifySuccess() {
        message.success('Successfully updated')
    }
    static notifyError(errors) {
        const errs = typeof errors === 'string' ? errors : Object.keys(errors).map(key => errors[key].map((e, i) => <span key={i}>{e}</span>));
        message.error(errs);
    }
    handlePostSubmit() {
        const {state: {serverErrors}} = this;
        if (!serverErrors) {
            Application.notifySuccess();
            return;
        }

        const {res: {errors, message}} = serverErrors;
        Application.notifyError(errors || message);
    }
    renderProfile() {
        const {
            id,
            business_name,
            address_line_1,
            address_line_2,
            address_line_3,
            post_code,
            latitude: lat,
            longitude: lng,
            contact_name,
            phone_number,
            email,
            gas_safe_registered,
            gas_safe_registration_no,
            contact_established,
            notes,
            rates_established,
            quote_sent,
            contract_sent,
            signed_contract_received,
            approved,
            contract_start_date,
            start_number,
            documents = [],
            isFetching
        } = this.props.application;
        const {next: {id: next}, previous: {id: prev}, location: {state: {from} = {}}} = this.props;
        const {patchApplication, uploadDocument, deleteDocument} = this.props;
        const {viewNotes} = this.state;

        const Navigation = () => (
            <Button.Group>
                <Button disabled={!prev}>
                    <Link to={{
                        pathname: `/admin/applications/${prev}`,
                        state: {from}
                    }}><Icon type="left" /></Link>
                </Button>
                <Button disabled={!next}>
                    <Link to={{
                        pathname: `/admin/applications/${next}`,
                        state: {from}
                    }}><Icon type="right" /></Link>
                </Button>
            </Button.Group>
        );

        const renderNotes = () => {
            if (!contact_established) {
                return;
            }

            const toggleNotes = () => {
                this.setState({
                    viewNotes: !viewNotes
                })
            };

            return (
                <Row>
                    <Col span={12}><p>View Notes: </p></Col>
                    <Col span={12}><Checkbox onChange={toggleNotes}/></Col>
                </Row>
            )
        };

        const onToggle = (field) => (e) => {
            const {checked} = e.target;
            return patchApplication(id, field, checked).then(() => this.handlePostSubmit());
        };
        const onBlur = (field) => (e) => {
            const {value} = e.target;
            return patchApplication(id, field, value).then(() => this.handlePostSubmit());
        };

        const onDateChange = field => (date, dateString) => {
            return patchApplication(id, field, dateString).then(() => this.handlePostSubmit());
        };
        const onChange = field => value => {
            value = value.target ? value.target.value : value;
            this.setState({
                [field]: value
            });
        };
        const approve = () => {
            return patchApplication(id, 'approved', true).then(() => this.handlePostSubmit());
        };
        const postUploadHandler = (file, onSuccess, onError) => {
            const {state: {serverErrors}} = this;
            if (!serverErrors) {
                file.status = 'done';
                return onSuccess(file);
            }

            const {res: {errors, message}} = serverErrors;
            file.status = 'error';
            file.response = message;
            Application.notifyError(errors);
            return onError(file);
        };
        const handleUpload = ({
            data,
            file,
            filename,
            onError,
            onProgress,
            onSuccess
        }) => {
            const formData = new FormData();
            if (data) {
                Object.keys(data).map(key => {
                    formData.append(key, data[key]);
                });
            }
            formData.append(filename, file);

            return uploadDocument(id, formData).then(() => postUploadHandler(file, onSuccess, onError));
        };
        const getDocument = (type) => {
            return {...documents.find(doc => doc.doc_type === type), isFetching};
        };
        const onDelete = (doc) => {
            return deleteDocument(id, doc.uid);
        };
        const getDateValue = (field) => {
            return field && moment(field.date, 'YYYY-MM-DD').format('DD/MM/YYYY');
        };
        const getDateObj = (field) => {
            return field && moment(field.date, 'YYYY-MM-DD');
        };

        const approveVisible = () => {
            return signed_contract_received &&
                !!contract_start_date &&
                !!start_number &&
                !!this.state.start_number;
        };
        return (
            <Card title={business_name} loading={this.props.isFetching} bordered={false} extra={<Navigation/>}>
                <Row gutter={16}>
                    <Col span={16}>
                        <Row>
                            <Col span={4}><p>Business Name: </p></Col><Col span={8}>{business_name}</Col>
                            <Col span={5}><p>Main Contact Name: </p></Col><Col span={7}>{contact_name}</Col>
                        </Row>
                        <Row>
                            <Col span={4}><p>Address Line 1: </p></Col><Col span={8}>{address_line_1}</Col>
                            <Col span={5}><p>Main Contact Tel: </p></Col><Col span={7}>{phone_number}</Col>
                        </Row>
                        <Row>
                            <Col span={4}><p>Address Line 2: </p></Col><Col span={8}>{address_line_2}</Col>
                            <Col span={5}><p>Main Contact Email: </p></Col><Col span={7}>{email}</Col>
                        </Row>
                        <Row>
                            <Col span={4}><p>Address Line 3: </p></Col>
                            <Col span={8}>{address_line_3}</Col>

                            <Col span={5}><p>Gas Safe Registered: </p></Col>
                            <Col span={7}><Checkbox disabled checked={gas_safe_registered}/></Col>
                        </Row>
                        <Row>
                            <Col span={4}><p>Post Code: </p></Col><Col span={8}>{post_code}</Col>
                            {gas_safe_registered ? (
                                <Col span={5}><p>Gas Safe Registration No : </p></Col>
                            ) : null}
                            {gas_safe_registered ? (
                                <Col span={7}>{gas_safe_registration_no}</Col>
                            ) : null}
                        </Row>
                        <Divider />
                        <Row>
                            <Col span={12}>
                                <Row>
                                    <Col span={12}><p>Contact Established: </p></Col>
                                    <Col span={2}><Checkbox disabled={!!approved} checked={!!contact_established} onChange={onToggle('contact_established')}/></Col>
                                    <Col span={10}>{getDateValue(contact_established)}</Col>
                                </Row>
                                <Row>
                                    <Col span={12}><p>Rates Established: </p></Col>
                                    <Col span={2}><Checkbox disabled={!!approved} checked={!!rates_established} onChange={onToggle('rates_established')}/></Col>
                                    <Col span={10}>{getDateValue(rates_established)}</Col>
                                </Row>
                                {renderNotes()}
                                {!!rates_established ? (
                                    <Row>
                                        <Col span={12}><p>Badge Cost Quoted: </p></Col>
                                        <Col span={12}><InputNumber disabled={!!approved} size="small" value={this.state.badge_cost_quoted} onBlur={onBlur('badge_cost_quoted')} onChange={onChange('badge_cost_quoted')} style={{ width: 200 }}/></Col>
                                    </Row>
                                ) : ''}
                                {!!rates_established ? (
                                    <Row>
                                        <Col span={12}><p>Property Cost Quoted: </p></Col>
                                        <Col span={12}><InputNumber disabled={!!approved} size="small" value={this.state.property_cost_quoted} onBlur={onBlur('property_cost_quoted')} onChange={onChange('property_cost_quoted')} style={{ width: 200 }}/></Col>
                                    </Row>
                                    ) : ''}
                                <Row>
                                    <Col span={12}><p>Number Of Properties: </p></Col>
                                    <Col span={12}><InputNumber disabled={!!approved} size="small" value={this.state.number_of_properties} onBlur={onBlur('number_of_properties')} onChange={onChange('number_of_properties')} style={{ width: 200 }}/></Col>
                                </Row>
                                <Row>
                                    <Col span={12}><p>Quote Sent: </p></Col>
                                    <Col span={2}><Checkbox disabled={!!approved} checked={!!quote_sent} onChange={onToggle('quote_sent')}/></Col>
                                    <Col span={10}>{getDateValue(quote_sent)}</Col>
                                </Row>
                                <Row>
                                    <Col span={12}><p>Contract Sent: </p></Col>
                                    <Col span={2}><Checkbox disabled={!!approved} checked={!!contract_sent} onChange={onToggle('contract_sent')}/></Col>
                                    <Col span={10}>{getDateValue(contract_sent)}</Col>
                                </Row>
                                <Row>
                                    <Col span={12}><p>Signed Contract Received: </p></Col>
                                    <Col span={2}><Checkbox disabled={!!approved} checked={!!signed_contract_received} onChange={onToggle('signed_contract_received')}/></Col>
                                    <Col span={10}>{getDateValue(signed_contract_received)}</Col>
                                </Row>
                                <Row>
                                    <Col span={12}><p>Contract Start Date: </p></Col>
                                    <Col span={2}>
                                        <DatePicker size="small" disabled={!!approved} defaultValue={getDateObj(contract_start_date)} format='DD/MM/YYYY' onChange={onDateChange('contract_start_date')} style={{ width: 200 }}/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}><p>Badge Start No.: </p></Col>
                                    <Col span={2}><Input size="small" disabled={!!approved} value={this.state.start_number} onBlur={onBlur('start_number')} onChange={onChange('start_number')} style={{ width: 200 }}/></Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                {viewNotes ? (
                                    <div>
                                        <span>Notes</span>
                                        <TextArea disabled={!!approved} rows={4} defaultValue={notes} onBlur={onBlur('notes')}/>
                                    </div>
                                ) : ''}
                            </Col>
                        </Row>
                        {approveVisible() ? <Divider /> : ''}
                        {approveVisible() ? (
                            <Button type='primary' size='large' disabled={!!approved} ghost={approved} onClick={approve}>Approve</Button>
                        ) : ''}
                    </Col>
                    <Col span={8} >
                        <Row>
                            <Col span={24}>
                                <Map {...{lat, lng}}/>
                            </Col>
                        </Row>
                        <br />

                        <Row type="flex" justify="space-between" gutter={16}>
                            {[
                                {label: "Upload Quote", docType: "Quote"},
                                {label: "Upload Contract", docType: "Contract"},
                                {label: "Upload Signed Contract", docType: "Signed Contract"},
                            ].map((i, key) => {
                                const {docType} = i;
                                return (
                                    <Col span={8} key={key}>
                                        <span>{docType}</span>
                                        <Document
                                            name="document" {...i}
                                            document={getDocument(docType)}
                                            onUpload={handleUpload}
                                            onRemove={onDelete}
                                            application={id}
                                        />
                                    </Col>
                                )
                            })}
                        </Row>
                    </Col>
                </Row>
            </Card>
        )
    }
    componentDidMount() {
        const {location: {state: {from} = {}}, application: {id: appId}} = this.props;
        if (appId) return;
        const [full, page] = from.match(/page=(\d+)/) || ['', 1];
        return this.props.fetchApplications(page);
    }
    render() {
        return (
            <div>
                {this.renderBreadcrump()}
                {this.renderProfile()}
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    const {match: {params: {id}}} = ownProps;
    const data = [...state.applications.data];
    const index = data.findIndex(a => a.id == id);
    const previous = data[index-1] || {};
    const next = data[index+1] || {};
    return {
        application: {...data[index]},
        previous,
        next,
        isFetching: state.applications.isFetching
    }
}

export default connect(mapStateToProps, {
    fetchApplications,
    patchApplication,
    uploadDocument,
    deleteDocument
})(Application);


// WEBPACK FOOTER //
// ./resources/assets/js/components/Application.js